import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives';
import { REASONS_MODAL_SHOWN } from '../../common/constants';
import { useACTAnalyticsEvents } from '../../common/utils';
import { useAdControlProvider } from '../../controllers';
import { messages } from '../messages';
import { DEFAULT_PORTAL_OVERRIDE_INDEX, overridePortalIndex } from '../utils/use-portal-index';
const adControlScreenName = 'adControlsReasonsModal';
const ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const ReasonsModal = ({
  body,
  itemId,
  title,
  zIndexOverride = DEFAULT_PORTAL_OVERRIDE_INDEX,
  ...props
}) => {
  const {
    closeModal,
    createEventDispatcher
  } = useAdControlProvider();
  const {
    createScreenUIEvent
  } = useACTAnalyticsEvents();
  const eventDispatcher = React.useMemo(() => itemId !== undefined && createEventDispatcher(itemId), [createEventDispatcher, itemId]);
  const isOpen = itemId !== undefined;
  useEffect(() => {
    if (isOpen && eventDispatcher) {
      eventDispatcher.dispatch(REASONS_MODAL_SHOWN, createScreenUIEvent(adControlScreenName));
    }
  }, [createScreenUIEvent, eventDispatcher, isOpen]);

  // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
  if (isOpen && zIndexOverride) {
    overridePortalIndex(ACT_MODAL_CONTENT, zIndexOverride);
  }
  // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence

  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(Modal, _extends({
    shouldCloseOnEscapePress: true,
    onClose: closeModal
  }, props), /*#__PURE__*/React.createElement(Box, {
    id: ACT_MODAL_CONTENT
  }, title !== null && /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, title !== null && title !== void 0 ? title : /*#__PURE__*/React.createElement(FormattedMessage, messages.showReasons))), /*#__PURE__*/React.createElement(ModalBody, null, body), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: closeModal,
    autoFocus: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.reasonsModalOkButton))))));
};
export default ReasonsModal;